import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import MaterialTable, { MTableToolbar } from "material-table";
import SlidingPane from "react-sliding-pane";
import "react-sliding-pane/dist/react-sliding-pane.css";
import ContentLoader from "react-content-loader";
import { ToastContainer } from "react-toastify";
import jsPDF from "jspdf";
// import "jspdf-autotable";
import { autoTable } from 'jspdf-autotable'
import _ from "lodash";
import Select from 'react-select';

import authHeader from "../../../services/auth-header";
import { API } from "../../../backend";
import Helper from "../../../Helper";
import { getTrans as t } from "../../../Localization/translations";
import lineOfBusinessService from "../../../services/company/lineofbusinessService";
import subcompanyService from "../../../services/company/subcompanyService";

function AllContractReport() {
  const tableRef = React.createRef();
  const [loading, setLoading] = useState(true);
  const [permissionss, setPermission] = useState(localStorage.getItem('permissions'))
  const permissionsArray = permissionss.split(',');
  var contractNumber = "";
  var customerName = "";
  const [state1, setState] = useState({
    isPaneOpen: false,
    isPaneOpenLeft: false,
  });
  const [selectedValue, setSelectedValue] = useState(null);
  const [options, setOptions] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [inputValue, setInputValue] = useState('');

  const [selectedValue2, setSelectedValue2] = useState(null);
  const [isLoading2, setIsLoading2] = useState(false);
  const [inputvalue2, setValue2] = useState("");
  const [currentPage2, setCurrentPage2] = useState(1);
  const [options2, setOptions2] = useState([]);

   const [subcompany, setSubcompany] = useState("");
    const [lineOfBusiness, setLineOfBusiness] = useState("");
    const [subcompanyOptions, setSubcompanyOptions] = useState([]);
    const [lineOfBusinessOptions, setLineOfBusinessOptions] = useState([]);


     const fetchSubcompanies = () => {
          try {
            subcompanyService.getSubcompany().then((response) => {
            const companies = response.data || [];
    
              setSubcompanyOptions(companies);
         
            });
          } catch (err) {
            console.error(err);
          }
        };
      
        // Fetch Lines of Business
        const fetchLinesOfBusiness = () => {
          try {
            lineOfBusinessService.getLineOfBusiness().then((response) => {
              const lobs = response.data || [];
          setLineOfBusinessOptions(lobs);
            setLineOfBusinessOptions(lobs);
           
            });
          } catch (err) {
           
            console.error(err);
          }
        };
        useEffect(() => {
              fetchSubcompanies();
              fetchLinesOfBusiness();
          }, []);

  const handelInputChange = (value) => {
    setInputValue(value);
    setCurrentPage(1);
    setOptions([]);
    loadOptions(value, 1);
  };

  const handleMenuScrollToBottomName = () => {
    loadOptions(inputValue, currentPage);
  };

  const handelChange = (value) => {
    setSelectedValue(value);
  };

  const loadOptions = async (value, page) => {
    try {
      if (value !== '') {
        setIsLoading(true);
        const response = await fetch(`${API}parties/party/?customer_name=${value}&page=${page}`, { headers: authHeader() });
        const newData = await response.json();

        if (newData && newData.data && newData.data.length > 0) {
          const newOptions = newData.data

          setOptions((prevOptions) => [...prevOptions, ...newOptions]);
          setCurrentPage((prevPage) => prevPage + 1);
        } else {
          console.error('No data received or empty array from API.');
        }
        setIsLoading(false);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      setIsLoading(false);
    }
  };

  let navigate = useNavigate();

  const handleView = (id, status, contract_type) => {
    if (status === "Active") {
      navigate("/contract/view", { state: id });
    } else if (status === "Terminated") {
      navigate("/contract/view", { state: id });
    } else {
      if (contract_type === "Loan") {
        navigate("/editloancontract", { state: id });
      } else {
        navigate("/contract/edit", { state: id });
      }
    }
  };

  const handlePartyView = (id) => {
    navigate("/party/details", { state: id });
  };

  const handleClear = () => {
    setSelectedValue(null);
    setSelectedValue2(null);
    setSubcompany("");
    setLineOfBusiness("");

    tableRef.current.onQueryChange();
  };

  const fetchAllDataForExport = async () => {
    let allData = [];
    let currentPage = 0;
    const pageSize = 10; // Your page size

    while (true) {
      const query = {
        pageSize,
        page: currentPage,
        search: '',
      };

      // Modify the logic here to handle customerName if needed
      let customerName = "";
      if (selectedValue) {
        customerName = selectedValue.id;
      }
      if (selectedValue2) {
        contractNumber = selectedValue2.contract_number
      }

      const url = API + "contracts/contracts/0/?" + query.pageSize + "&page=" + (query.page + 1) + "&search=" + query.search + "&contractNumber=" + contractNumber + "&customerName=" + customerName;

      try {
        const response = await fetch(url, { headers: authHeader() });
        const result = await response.json();

        if (result.data.length === 0) {
          break;
        }

        allData = allData.concat(result.data);
        currentPage++;
      } catch (error) {
        console.error("Error fetching data:", error);
        break;
      }
    }

    return allData;
  };

  useEffect(() => {
    setLoading(false);
  }, []);

  //for number
  const handleInputChangeData = (value) => {
    setValue2(value);
    setCurrentPage2(1);
    setOptions2([]);
    loadOptionsData(value, 1);
  };

  const handleMenuScrollToBottom = () => {
    loadOptionsData(inputvalue2, currentPage2);
  };

  const loadOptionsData = async (value, page) => {
    try {
      if (value !== '') {
        setIsLoading2(true);
        const response = await fetch(`${API}contracts/contracts/filter/?id=${value}&page=${page}`, { headers: authHeader() });
        const newData = await response.json();

        if (newData && newData.data && newData.data.length > 0) {
          const newOptions = newData.data

          setOptions2((prevOptions) => [...prevOptions, ...newOptions]);
          setCurrentPage2((prevPage) => prevPage + 1);
        } else {
          console.error('No data received or empty array from API.');
        }
        setIsLoading2(false);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      setIsLoading2(false);
    }
  };
  const handelChange2 = (value1) => {
    setSelectedValue2(value1);
  };

  function getAlignmentStyles(columns) {
    const alignmentStyles = {};
    columns.forEach((columnDef, index) => {
        if (columnDef.field === 'financed_amount') {
            alignmentStyles[index] = { halign: 'right' };
        } else {
            alignmentStyles[index] = { halign: 'left' };
        }
    });
    return alignmentStyles;
}

  return (
    <>
      {loading === false ? (
        <div className="page-wrapper">
          <ToastContainer />
          <div className="">
            <div className="row show_contract show_invoice">
              <div className="">
                <div className="col-md-12 ">
                  <div className="">
                    <div className="body">
                      <div className=" p-0">
                        <MaterialTable
                          tableRef={tableRef}
                          style={{
                            backgroundColor: "var(--bs-table-bg)",
                            borderBottomWidth: "1px",
                            boxShadow:
                              "inset 0 0 0 9999px var(--bs-table-accent-bg)",
                          }}
                          title={<h5 className="mb-0">{t("Contracts")}</h5>}
                          columns={[
                            {
                              title: `${t("Contract Number")}`,
                              field: "contract_number",
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "left",
                              },
                              cellStyle: {
                                textAlign: "left",
                                fontSize: 12,
                              },
                              render: (rowData) => (
                                <>
                                  {" "}
                                  <div className="d-xl-none tc d-md-none d-lg-none">
                                    {t("Contract Number")}
                                  </div>
                                  <div
                                    className="hyperlink"
                                    onClick={() =>
                                      rowData.status === "Entered" ?
                                        permissionss && permissionsArray.includes('change_contract') === true && handleView(
                                          rowData.id,
                                          rowData.status,
                                          rowData.contract_type
                                        ) :
                                        permissionss && permissionsArray.includes('view_contract') === true &&
                                        handleView(
                                          rowData.id,
                                          rowData.status,
                                          rowData.contract_type
                                        )

                                    }
                                  >
                                    {rowData.contract_number}
                                  </div>
                                </>
                              ),
                            },
                            {
                              title: `${t("Customer")}`,
                              field: "customer_name",
                              render: (rowData) => (
                                <>
                                  <div className="d-xl-none tc d-md-none d-lg-none">
                                    {t("Customer")}
                                  </div>{" "}
                                  <div
                                    className="hyperlink"
                                    onClick={() =>
                                      handlePartyView(rowData.party)
                                    }
                                  >
                                    {rowData.customer_name}
                                  </div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "left",
                              },
                              cellStyle: {
                                textAlign: "left",
                                fontSize: 12,
                              },
                            },
                            {
                              title: `${t("Contract Type")}`,
                              field: "contract_type",
                              render: (rowData) => (
                                <>
                                  <div className="d-xl-none tc d-md-none d-lg-none">
                                    {" "}
                                    {t("Contract Type")}
                                  </div>
                                  <div>{rowData.contract_type}</div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "left",
                              },
                              cellStyle: {
                                textAlign: "left",
                                fontSize: 12,
                              },
                            },
                            {
                              title: `${t("Sub Company")}`,
                              field: "subcompany_name",
                              render: (rowData) => (
                                <>
                                  <div className="d-xl-none tc d-md-none d-lg-none">
                                    {" "}
                                    {t("Sub Company")}
                                  </div>
                                  <div>{rowData.subcompany_name}</div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "left",
                              },
                              cellStyle: {
                                textAlign: "left",
                                fontSize: 12,
                              },
                            },
                            {
                              title: `${t("Line of Business")}`,
                              field: "line_of_business_name",
                              render: (rowData) => (
                                <>
                                  <div className="d-xl-none tc d-md-none d-lg-none">
                                    {" "}
                                    {t("Line of Business")}
                                  </div>
                                  <div>{rowData.line_of_business_name}</div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "left",
                              },
                              cellStyle: {
                                textAlign: "left",
                                fontSize: 12,
                              },
                            },
                            {
                              title: `${t("Start Date")}`,
                              field: "start_date",
                              render: (rowData) => (
                                <>
                                  <div className="d-xl-none tc d-md-none d-lg-none">
                                    {t("Start Date")}
                                  </div>
                                  <div>
                                    {Helper.DateNormal(rowData.start_date)}
                                  </div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "left",
                              },
                              cellStyle: {
                                textAlign: "left",
                                fontSize: 12,
                              },
                            },
                            {
                              title: `${t("Term")}`,
                              field: "contract_term",
                              render: (rowData) => (
                                <>
                                  <div className="d-xl-none tc d-md-none d-lg-none">
                                    {t("Term")}
                                  </div>
                                  <div>{rowData.contract_term}</div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "left",
                              },
                              cellStyle: {
                                textAlign: "left",
                                fontSize: 12,
                              },
                            },
                            {
                              title: `${t("End Date")}`,
                              field: "end_date",
                              render: (rowData) => (
                                <>
                                  <div className="d-xl-none tc d-md-none d-lg-none">
                                    {t("End Date")}
                                  </div>
                                  <div>
                                    {rowData.end_date
                                      ? Helper.DateNormal(rowData.end_date)
                                      : "None"}
                                  </div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "left",
                              },
                              cellStyle: {
                                textAlign: "left",
                                fontSize: 12,
                              },
                            },
                            {
                              title: `${t("Payment Date")}`,
                              field: "paymentstartdate",
                              render: (rowData) => (
                                <>
                                  <div className="d-xl-none tc d-md-none d-lg-none">
                                    {t("Payment Date")}
                                  </div>
                                  <div>
                                    {rowData.paymentstartdate
                                      ? Helper.DateNormal(
                                        rowData.paymentstartdate
                                      )
                                      : "None"}
                                  </div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "left",
                              },
                              cellStyle: {
                                textAlign: "left",
                                fontSize: 12,
                              },
                            },
                            {
                              title: `${t("Terminate Date")}`,
                              field: "termination_date",
                              render: (rowData) => (
                                <>
                                  <div className="d-xl-none tc d-md-none d-lg-none">
                                    {t("Termination Date")}
                                  </div>
                                  <div>
                                    {rowData.termination_date
                                      ? Helper.DateNormal(
                                        rowData.termination_date
                                      )
                                      : "None"}
                                  </div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "left",
                              },
                              cellStyle: {
                                textAlign: "left",
                                fontSize: 12,
                              },
                            },
                            {
                              title: `${t("Financed Amount")}`,
                              field: "financed_amount",
                              render: (rowData) => (
                                <>
                                  <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                                  >
                                    {t("Financed Amount")}
                                  </div>
                                  <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>
                                    {rowData.financed_amount === 0
                                      ? Helper.Amount(rowData.financed_amount)
                                      : Helper.Amount(
                                        rowData.financed_amount -
                                        rowData.deposit_amount
                                      )}
                                  </div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "right",
                              },
                              // cellStyle: {
                              //   textAlign: "right",
                              //   fontSize: 12,
                              // },
                            },
                            {
                              title: `${t("Status")}`,
                              field: "status",
                              render: (rowData) => (
                                <>
                                  <div className="d-xl-none tc d-md-none d-lg-none">
                                    {t("Status")}
                                  </div>
                                  <div
                                    className={
                                      rowData.status === "Active"
                                        ? "badge bg-gradient-success text-xxs"
                                        : rowData.status === "Terminated" || rowData.status === "PaidOff"
                                          ? "badge bg-gradient-danger text-xxs"
                                          : "badge badge-sm bg-gradient-secondary"
                                    }
                                  >
                                    {rowData.status}
                                  </div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "left",
                              },
                              cellStyle: {
                                textAlign: "left",
                                fontSize: 12,
                              },
                            },
                          ]}
                          data={(query) =>
                            new Promise((resolve, reject) => {
                              const { orderBy, orderDirection } = query;
                              let subcompanyParam = subcompany || "";
                              let lineOfBusinessParam = lineOfBusiness || "";
                              if (selectedValue2 && selectedValue) {
                                contractNumber = selectedValue2.contract_number;
                                customerName = selectedValue.id;
                              } else if (selectedValue2) {
                                contractNumber = selectedValue2.contract_number;
                              } else if (selectedValue) {
                                customerName = selectedValue.id;
                              }
                              let url = API + "contracts/contracts/0/?";
                              url += "per_page=" + query.pageSize;
                              url += "&page=" + (query.page + 1);
                              url += "&search=" + query.search;
                              url += `&contractNumber=${contractNumber !== "" ? contractNumber : ""
                                }`;
                              url += `&customerName=${customerName !== "" ? customerName : ""
                                }`;
                              url += `&subcompany=${subcompanyParam}`;
                              url += `&line_of_business=${lineOfBusinessParam}`;
                              if (orderBy) {
                                url += `&orderBy=${orderBy.field}`;
                                url += `&orderDirection=${orderDirection}`;
                              }
                              fetch(url, { headers: authHeader() })
                                .then((response) => response.json())
                                .then((result) => {
                                  resolve({
                                    data:
                                      query.orderBy && query.orderDirection
                                        ? _.orderBy(
                                          result.data,
                                          [query.orderBy.field],
                                          [query.orderDirection]
                                        )
                                        : result.data,
                                    page: result.page - 1,
                                    totalCount: result.total,
                                  });
                                });
                            })
                          }
                          localization={{
                            toolbar: {
                              searchPlaceholder: "Search Contracts",
                            },
                          }}
                          components={{
                            Toolbar: (props) => (
                              <div className="MuiToolbar-root MTableToolbar-spacer-21  my-temp-class">
                                <MTableToolbar {...props} />

                                <span
                                  onClick={() => setState({ isPaneOpen: true })}
                                  style={{
                                    color: "#b4b7c5",
                                    paddingRight: "10px",
                                    cursor: "pointer",
                                  }}
                                >
                                  <img
                                    src={
                                      process.env.PUBLIC_URL +
                                      "/static/images/ic-filter.svg"
                                    }
                                    alt=""
                                  />
                                </span>
                              </div>
                            ),
                          }}
                          options={{
                            headerStyle: {
                              backgroundColor: "white",
                              color: "#245C7F",
                              fontSize: 11,
                            },
                            rowStyle: (rowData, index) => {
                              if (index % 2) {
                                return { backgroundColor: "#fff" };
                              }
                            },
                            sorting: true,
                            search: true,
                            toolbar: true,
                            paging: true,
                            pageSize: 10, // make initial page size
                            emptyRowsWhenPaging: false, // To avoid of having empty rows
                            pageSizeOptions: [10, 20, 25, 50],
                            paginationType: "stepped",
                            showFirstLastPageButtons: false,
                            exportAllData: true,
                            exportButton: true,
                            exportFileName: "Contracts",
                            exportCsv: async (columns, data) => {
                              try {
                                  const allData = await fetchAllDataForExport(); // Fetch all data
                                  if (allData.length === 0) {
                                      console.error("No data found for CSV export");
                                      return;
                                  }
                          
                                  const csvColumns = Helper.visibleColumn(columns); // Filter out hidden columns
                                  const csvColumnTitles = csvColumns.map(column => column.title);
                          
                                  const title = "Contract Report";
                                  const currentDate = new Date().toLocaleDateString();
                          
                                  let csvContentWithInfo = `${title}\n`;
                                  if (selectedValue !== null) {
                                      const selectedVal = selectedValue.customer_name;
                                      csvContentWithInfo += `Filter By Customer Name : ${selectedVal}\n`;
                                  }
                                  if (selectedValue2 !== null) {
                                      const selectedVal2 = selectedValue2.contract_number;
                                      csvContentWithInfo += `Filter By Contract Number : ${selectedVal2}\n`;
                                  }
                                  csvContentWithInfo += `Date: ${currentDate}\n\n`;
                          
                                  const csvData = allData.map(rowData =>
                                      csvColumns.map(columnDef => {
                                          if (columnDef.field === "customer_name") {
                                              return rowData.customer_name ? rowData.customer_name : "";
                                          } else if (columnDef.field === 'start_date' || columnDef.field === 'end_date' || columnDef.field === 'paymentstartdate') {
                                              return rowData[columnDef.field] ? Helper.DateNormal(rowData[columnDef.field]) : "";
                                          } else {
                                              return rowData[columnDef.field];
                                          }
                                      })
                                  );
                          
                                  const csvRows = [csvColumnTitles, ...csvData];
                                  const csvContent = `${csvContentWithInfo}${csvRows.map(row => row.join(',')).join('\n')}`;
                          
                                  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
                                  const link = document.createElement('a');
                                  link.href = URL.createObjectURL(blob);
                                  link.download = 'contract.csv';
                                  link.style.display = 'none';
                                  document.body.appendChild(link);
                                  link.click();
                                  document.body.removeChild(link);
                              } catch (error) {
                                  console.error("Error exporting CSV:", error);
                              }
                          },
                          
                            exportPdf: async (columns, data) => {
                              const allData = await fetchAllDataForExport(); // Fetch all data
                              if (allData.length === 0) {
                                  console.error("No data found for PDF export");
                                  return;
                              }
                          
                              // Filter out hidden columns
                              const visibleColumns = Helper.visibleColumn(columns);
                              
                              const doc = new jsPDF();
                              doc.setFont("helvetica", "bold");
                              doc.setFontSize(16);
                          
                              const title = "Contract Report";
                              doc.text(title, 14, 10);
                          
                              doc.setFontSize(12);
                              doc.setFont("helvetica", "normal");
                              const currentDate = new Date().toLocaleDateString();
                              doc.text(`Date : ${currentDate}`, 14, 15);
                          
                              if (selectedValue !== null || selectedValue2 !== null) {
                                const selectedVal = selectedValue?.customer_name;
                                const selectedVal2 = selectedValue2?.contract_number;
                                 if(selectedValue !== null & selectedValue2 !== null){
                                  doc.text(`Filter By Customer Name and Contract Number : ${selectedVal === 'undefined'?"":selectedVal} and ${selectedVal2 ==='undefined'?"":selectedVal2}`, 14, 20);
                                }
                                else if (selectedValue!==null){
                                  doc.text(`Filter By Customer Name : ${selectedVal === 'undefined'?"":selectedVal} `, 14, 20);
                                }
                                else if(selectedValue2!==null){
                                  
                                  doc.text(`Filter By  Contract Number : ${selectedVal2 === 'undefined'?"":selectedVal2}`, 14, 20);
                                }
                              }
                          
                              // Set the space between the filter title and the table
                              const space = 22; // Adjust the space value as needed
                              const tableStartY = 5 + space;
                          
                              const columnTitles = visibleColumns.map(columnDef => columnDef.title);
                              const pdfData = allData.map(rowData =>
                                  visibleColumns.map(columnDef => {
                                      if (columnDef.field === "customer_name") {
                                          return rowData.customer_name ? rowData.customer_name : "";
                                      } else if (columnDef.field === 'start_date' || columnDef.field === 'end_date' || columnDef.field === 'paymentstartdate') {
                                          return rowData[columnDef.field] ? Helper.DateNormal(rowData[columnDef.field]) : "";
                                      } else {
                                          return rowData[columnDef.field];
                                      }
                                  })
                              );
                              const tableData = [columnTitles, ...pdfData];
                          
                              // Draw the table with adjusted y-coordinate
                              // doc.autoTable({
                              autoTable(doc,{
                                  head: [tableData[0]], // Column headers
                                  body: tableData.slice(1), // Data excluding headers
                                  startY: tableStartY ,// Set the starting y-coordinate for the table
                                  columnStyles: getAlignmentStyles(visibleColumns) // Apply column alignment styles

                              });
                          
                              doc.save(`contract.pdf`);
                          },
                            actionsColumnIndex: -1,
                            columnsButton: true,
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <SlidingPane
                    className="some-custom-class"
                    overlayClassName="some-custom-overlay-class"
                    isOpen={state1.isPaneOpen}
                    title="Filter By"
                    subtitle=""
                    onRequestClose={() => {
                      // triggered on "<" on left top click or on outside click
                      setState({ isPaneOpen: false });
                    }}
                  >
                    {/* <div className="row"> */}
                    <div className="col-md-12">
                        <label className="col-form-label">{t("Sub Company")}</label>
                        <select
                          className="form-select form-control"
                          // value={subcompany}
                          name="subcompany"
                            onChange=  {(e) =>
                              setSubcompany(e.target.value)    
                          }
                        >
                          <option value="">Select Company</option>
                          {subcompanyOptions.map((sub) => (
                            <option key={sub.id} value={sub.id}>
                              {sub.sub_company_name}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="col-md-12">
                        <label className="col-form-label">{t("Line of Business")} </label>
                        <select
                          className="form-select form-control"
                          // value={lineOfBusiness}
                          name="lineOfBusiness"
                          onChange= {(e)=>
                                setLineOfBusiness(e.target.value)
                          }
                        
                        >
                          <option value="">Select Line of Business</option>
                          {lineOfBusinessOptions.map((lob) => (
                            <option key={lob.id} value={lob.id}>
                              {lob.lob_name}
                            </option>
                          ))}
                        </select>
                    </div>
                    <div className="col-xl-12">
                      <div className="form-group row">
                        <label className="col-lg-12 col-form-label">
                          {t("Customer Name")}
                        </label>
                        <div className="col-lg-12">
                          <Select
                            value={selectedValue}
                            filterOption={false}
                            options={options}
                            isClearable
                            onInputChange={handelInputChange}
                            getOptionLabel={(options) => options.customer_name}
                            getOptionValue={(options) => options.customer_name}
                            isLoading={isLoading}
                            placeholder={t("Search for Customer(%for All)")}
                            onMenuScrollToBottom={handleMenuScrollToBottomName}
                            onChange={handelChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-12">
                      <div className="form-group row">
                        <label className="col-lg-12 col-form-label">
                          {t("Contract Number")}
                        </label>
                        <div className="col-lg-12">
                          <Select
                            value={selectedValue2}
                            filterOption={false}
                            options={options2}
                            isClearable
                            onInputChange={handleInputChangeData}
                            getOptionLabel={(options) => options.contract_number}
                            getOptionValue={(options) => options.contract_number}
                            isLoading={isLoading2}
                            placeholder={t("Search for Contract(%for All)")}
                            onMenuScrollToBottom={handleMenuScrollToBottom}
                            onChange={handelChange2}
                          />
                        </div>
                        <input type="hidden" id="contract_status" value="" />
                      </div>
                    </div>
                    <div className="col-xl-12">
                      <div className="form-group row">
                        <div
                          className="col-lg-12 text-left"
                          style={{ marginTop: "30px" }}
                        >
                          <button
                            type="button"
                            className="clearReceipt btn bg-gradient-secondary btn-m ms-auto mb-0"
                            onClick={handleClear}
                          >
                            {t("Reset")}
                          </button>
                          &nbsp;&nbsp;
                          <button
                            type="button"
                            className="filter add btn btn-primary btn-m ms-auto mb-0"
                            onClick={() => Helper.handleSearch(tableRef)}
                          >
                            {t("Apply")}
                          </button>
                          &nbsp;&nbsp;
                        </div>
                      </div>
                    </div>
                  </SlidingPane>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <ContentLoader
          viewBox="0 0 1000 550"
          backgroundColor="rgba(0,0,0,0.06)"
          foregroundColor="rgba(0,0,0,0.12)"
        >
          <rect x="51" y="45" rx="3" ry="3" width="906" height="17" />
          <circle cx="879" cy="123" r="11" />
          <circle cx="914" cy="123" r="11" />
          <rect x="104" y="115" rx="3" ry="3" width="141" height="15" />
          <rect x="305" y="114" rx="3" ry="3" width="299" height="15" />
          <rect x="661" y="114" rx="3" ry="3" width="141" height="15" />
          <rect x="55" y="155" rx="3" ry="3" width="897" height="2" />
          <circle cx="880" cy="184" r="11" />
          <circle cx="915" cy="184" r="11" />
          <rect x="105" y="176" rx="3" ry="3" width="141" height="15" />
          <rect x="306" y="175" rx="3" ry="3" width="299" height="15" />
          <rect x="662" y="175" rx="3" ry="3" width="141" height="15" />
          <rect x="56" y="216" rx="3" ry="3" width="897" height="2" />
          <circle cx="881" cy="242" r="11" />
          <circle cx="916" cy="242" r="11" />
          <rect x="106" y="234" rx="3" ry="3" width="141" height="15" />
          <rect x="307" y="233" rx="3" ry="3" width="299" height="15" />
          <rect x="663" y="233" rx="3" ry="3" width="141" height="15" />
          <rect x="57" y="274" rx="3" ry="3" width="897" height="2" />
          <circle cx="882" cy="303" r="11" />
          <circle cx="917" cy="303" r="11" />
          <rect x="107" y="295" rx="3" ry="3" width="141" height="15" />
          <rect x="308" y="294" rx="3" ry="3" width="299" height="15" />
          <rect x="664" y="294" rx="3" ry="3" width="141" height="15" />
          <rect x="58" y="335" rx="3" ry="3" width="897" height="2" />
          <circle cx="881" cy="363" r="11" />
          <circle cx="916" cy="363" r="11" />
          <rect x="106" y="355" rx="3" ry="3" width="141" height="15" />
          <rect x="307" y="354" rx="3" ry="3" width="299" height="15" />
          <rect x="663" y="354" rx="3" ry="3" width="141" height="15" />
          <rect x="57" y="395" rx="3" ry="3" width="897" height="2" />
          <circle cx="882" cy="424" r="11" />
          <circle cx="917" cy="424" r="11" />
          <rect x="107" y="416" rx="3" ry="3" width="141" height="15" />
          <rect x="308" y="415" rx="3" ry="3" width="299" height="15" />
          <rect x="664" y="415" rx="3" ry="3" width="141" height="15" />
          <rect x="55" y="453" rx="3" ry="3" width="897" height="2" />
          <rect x="51" y="49" rx="3" ry="3" width="2" height="465" />
          <rect x="955" y="49" rx="3" ry="3" width="2" height="465" />
          <circle cx="882" cy="484" r="11" />
          <circle cx="917" cy="484" r="11" />
          <rect x="107" y="476" rx="3" ry="3" width="141" height="15" />
          <rect x="308" y="475" rx="3" ry="3" width="299" height="15" />
          <rect x="664" y="475" rx="3" ry="3" width="141" height="15" />
          <rect x="55" y="513" rx="3" ry="3" width="897" height="2" />
          <rect x="52" y="80" rx="3" ry="3" width="906" height="17" />
          <rect x="53" y="57" rx="3" ry="3" width="68" height="33" />
          <rect x="222" y="54" rx="3" ry="3" width="149" height="33" />
          <rect x="544" y="55" rx="3" ry="3" width="137" height="33" />
          <rect x="782" y="56" rx="3" ry="3" width="72" height="33" />
          <rect x="933" y="54" rx="3" ry="3" width="24" height="33" />
        </ContentLoader>
      )}
    </>
  );
}

export default AllContractReport;
